var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-container"},[_c('listarProfesiograma')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }